import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import { addDevice } from './device.actions';
import { addLimitedRangeSystemIdentificationParameters } from './limited-range-system-identification-parameter.actions';
import {
  allLimitedRangeSystemIdentificationParameters,
  LimitedRangeSystemIdentificationParameter,
  limitedRangeSystemIdentificationParameterId,
} from './limited-range-system-identification-parameter.model';
import { createLimitedRangeSystemIdentificationParameterByIdSelector } from './limited-range-system-identification-parameter.selectors';

import { AppState } from './index';

@Injectable()
export class LimitedRangeSystemIdentificationParameterEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<AppState>>(Store);

  addLimitedRangeSystemIdentificationParametersOnAddDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addDevice),
      withLatestFrom(this.store$),
      map(([action, state]) => {
        const device = action.device;
        const limitedRangeSystemIdentificationParameters: LimitedRangeSystemIdentificationParameter[] = [];

        allLimitedRangeSystemIdentificationParameters.map((limitedRangeSystemIdentificationParameter) => {
          const deviceLimitedRangeSystemIdentificationParameter =
            createLimitedRangeSystemIdentificationParameterByIdSelector(
              limitedRangeSystemIdentificationParameterId(limitedRangeSystemIdentificationParameter, device),
            ).projector(state.limitedRangeSystemIdentificationParameters.entities);

          if (!deviceLimitedRangeSystemIdentificationParameter) {
            limitedRangeSystemIdentificationParameters.push({
              ...limitedRangeSystemIdentificationParameter,
              deviceSerialNumber: device.serialNumber,
              id: limitedRangeSystemIdentificationParameterId(limitedRangeSystemIdentificationParameter, device),
            } as LimitedRangeSystemIdentificationParameter);
          }
        });

        return addLimitedRangeSystemIdentificationParameters({ limitedRangeSystemIdentificationParameters });
      }),
    ),
  );
}
